<script lang="ts">
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "Zeile",
  components: {},
  props: {
    class: String,
    spacingY: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const allClasses = computed(() => {
      return "o-grid zeile " + (props.class ? " " + props.class : "");
    });

    return {
      allClasses,
    };
  },
});
</script>

<template>
  <div :class="allClasses">
    <slot></slot>
  </div>
</template>

<style></style>
